<template>
  <b-row>
    <b-col md="4">
      <label>Forma de Pago*</label>
    </b-col>
    <b-col md="8">
      <b-form-select v-model="tipoCuotaElegida" :disabled="disabled">
        <b-form-select-option disabled selected value="">
          Seleccione la Forma de Pago de la Cuota
        </b-form-select-option>
        <b-form-select-option v-for="fp in opcionesTipoCuota" :key="fp.id" :value="fp.id">
          {{ fp.nombre }}
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "opcionesTipoCuota"]),
    tipoCuotaElegida: {
      get() {
        return this.oferta.tipoCuota;
      },
      set(value) {
        this.oferta.tipoCuota = value;
      },
    },
  },
};
</script>
